/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

var About = "关于";
var Access = "访问";
var Account = "帐户";
var Actions = "操作";
var Active = "活动";
var Add = "添加";
var Address = "地址";
var Advanced = "高级";
var Aliases = "别名";
var all = "全部";
var All = "全部";
var Apply = "应用";
var April = "四月";
var Arbitrary = "任意";
var Assign = "分配";
var August = "八月";
var Back = "后退";
var Basic = "基本";
var BNPP_EU = "法国巴黎银行（欧洲）";
var Cancel = "取消";
var Category = "类别";
var Classic = "经典";
var Clear = "清除";
var CLI = "CLI";
var Close = "关闭";
var Clusters = "集群";
var code = "代码";
var Complete = "完成";
var Completed = "已完成";
var Compliance = "Compliance";
var Compliant = "合规";
var Configuration = "配置";
var Configure = "配置";
var Confirm = "确认";
var Connect = "连接";
var Connected = "已连接";
var Connecting = "连接";
var Containers = "容器";
var Country = "国家或地区";
var Create = "创建";
var Created = "创建时间";
var Creating = "正在创建";
var Critical = "严重";
var Current = "当前";
var Custom = "定制";
var Dallas = "达拉斯";
var Datacenter = "数据中心";
var Datacenters = "数据中心";
var December = "十二月";
var Delete = "删除(T)";
var Deleting = "正在删除";
var Deploying = "部署";
var Disabled = "已禁用";
var Disconnect = "断开连接";
var Docs = "文档";
var Documentation = "文档";
var Done = "完成";
var Download = "下载";
var Draft = "草稿";
var Edit = "编辑";
var Enabled = "已启用";
var Encryption = "加密";
var End = "结束";
var Enterprise = "企业";
var Establish = "建立";
var Expired = "已到期";
var Failed = "失败";
var February = "二月";
var Filter = "过滤";
var Filters = "过滤器";
var Finalizing = "正在完成";
var Frankfurt = "法兰克福";
var Free = "免费";
var Friday = "星期五";
var Geography = "地域";
var Help = "帮助";
var hour = "小时";
var Hour = "小时";
var hr = "小时";
var IAM = "IAM";
var ID = "标识";
var Images = "映像";
var Inactive = "不活动";
var Incomplete = "不完整";
var Information = "信息";
var Infrastructure = "基础架构";
var Instance = "实例";
var Instances = "实例数";
var Integrations = "集成";
var Invalid = "无效";
var January = "一月";
var July = "七月";
var June = "六月";
var Key = "键";
var Launch = "启动";
var Lite = "Lite";
var Loading = "正在装入";
var Location = "地区";
var Locations = "位置";
var Logging = "日志记录";
var London = "伦敦";
var March = "三月";
var May = "五月";
var Metro = "地铁";
var Minute = "分钟";
var mo = "月";
var Monday = "星期一";
var Monitoring = "Monitoring";
var Month = "月";
var more = "更多";
var Name = "名称";
var Namespace = "名称空间";
var Namespaces = "名称空间";
var Next = "下一步";
var No = "否";
var None = "无";
var Normal = "正常";
var Note = "注释";
var Notification = "通知";
var November = "十一月";
var Objects = "Objects";
var October = "十月";
var Off = "关闭";
var OK = "OK";
var On = "打开";
var Open = "打开";
var Osaka = "大板";
var Overview = "概述";
var Packages = "包";
var Pattern = "模式";
var Pending = "暂挂";
var Plan = "套餐";
var Premium = "高级";
var Previous = "上一步";
var Product = "产品";
var Products = "产品";
var Project = "项目";
var Projects = "项目";
var Property = "属性";
var provided = "已提供";
var Provider = "提供者";
var Provisioning = "正在供应";
var Ready = "就绪";
var Refresh = "刷新";
var region = "区域";
var Region = "区域";
var Remove = "除去";
var Renew = "更新";
var Repositories = "存储库";
var Requested = "已请求";
var Required = "必需";
var Reservations = "保留";
var Reset = "重置";
var resources = "资源";
var Resources = "资源";
var Results = "结果";
var Review = "复审";
var Routing = "路由";
var Satellite = "Satellite";
var Saturday = "星期六";
var Save = "保存";
var Scanning = "正在扫描";
var Schedule = "日程安排";
var Search = "搜索";
var Secret = "私钥";
var Select = "选择";
var Sending = "正在发送";
var September = "九月";
var Serverless = "无服务器";
var Service = "服务";
var Settings = "设置";
var Size = "大小";
var Sort = "排序";
var Source = "源";
var Start = "Start";
var State = "州/省";
var Status = "状态";
var Storage = "存储器";
var Submit = "提交";
var Subscription = "预订";
var Success = "成功";
var Summary = "摘要";
var Sunday = "周日";
var Sydney = "悉尼";
var tag = "标记";
var tags = "标记";
var Tags = "标记";
var Thursday = "星期四";
var Tokyo = "东京";
var Topics = "主题";
var Toronto = "多伦多";
var Total = "总计";
var Trash = "废纸篓";
var Trial = "试用";
var Tuesday = "星期二";
var Unknown = "未知";
var Unsupported = "不受支持";
var Update = "更新";
var Upgrade = "升级";
var Value = "值";
var Values = "值";
var Version = "版本";
var View = "查看";
var Warning = "警告";
var Wednesday = "星期三";
var Workloads = "工作负载";
var Yes = "是";
var Zone = "专区";
var Zones = "专区";
var zhCn = {
	"'{{namespace}}' already exists. Enter another name.": "“{{namespace}}”已存在。 请选择其他名称。",
	"'Day of week' matches in addition to 'Day of month'": "除了“月中的日期”外，还有“星期几”应匹配",
	"'Day of week' matches in addition to 'Day of month'. The expression triggers every day.": "除了“月中的日期”外，还有“星期几”应匹配。 表达式每天触发。",
	"(IAM)": "(IAM)",
	"{{count}} items selected": "已选择 {{count}} 项",
	"{{count}} resources": "{{count}} 个资源",
	"{{count}} resources included": "包含 {{count}} 个资源",
	"{{current}} of {{total}} pages": "第 {{current}} 页，共 {{total}} 页",
	"{{datahookName}} response": "{{datahookName}} 响应",
	"{{instance_name}} ( {{region}} )": "{{instance_name}} ( {{region}} )",
	"{{label}} patterns": "{{label}} 模式",
	"{{min}}–{{max}} items": "第 {{min}}–{{max}} 项",
	"{{min}}–{{max}} of {{total}} items": "第 {{min}}–{{max}} 项（共 {{total}} 项）",
	"{{moduleCount}} modules, {{resourcesCount}} resources": "{{moduleCount}} 个模块，{{resourcesCount}} 个资源",
	"{{name}} requires the following option(s) in order to deploy.": "{{name}} 需要以下选项才能部署。",
	"{{price}} per {{unit}}": "每 {{unit}} {{price}}",
	"{{price}} per month": "{{price}}/月",
	"{{price}}/{{unit}}": "{{price}}/{{unit}}",
	"{{price}}/mo": "{{price}}/月",
	"{{resourcesCount}} resources": "{{resourcesCount}} 个资源",
	"{{rolesCount}} Role": "{{rolesCount}} 个角色",
	"{{rolesCount}} Roles": "{{rolesCount}} 个角色",
	"{{topicsCount}} topic active for this instance.": "此实例的 {{topicsCount}} 个主题处于活动状态",
	"{{topicsCount}} topics active for this instance.": "此实例的 {{topicsCount}} 个主题处于活动状态。",
	"{{value}} percent status progress": "{{value}} 状态进度百分比",
	"{{version}} (create a new cluster to try out this beta version)": "{{version}}（创建新集群以试用此 Beta 版本）",
	"{{version}} (update to an earlier version first)": "{{version}}（首先更新为较早的版本）",
	"<span>You must have a Cloud Object Storage instance to create a Satellite location.</span> <a>Learn more.</a>": "<span>您必须拥有一个 Cloud Object Storage 实例以创建 Satellite 位置。</span> <a>了解更多信息。</a>",
	"$0.00": "$0.00",
	"$0.00 / instance": "$0.00 / 实例",
	"1 item selected": "已选择 1 项",
	"1 of 1 page": "第 1 页（共 1 页）",
	"1 role": "1 个角色",
	"1–1 of 1 item": "1–1 项（共 1 项）",
	"A collection of keys that belong to your service instance.": "属于服务实例的密钥集合。",
	"A key can only have 5 aliases.": "一个密钥只能有 5 个别名。",
	"A Key Protect key": "Key Protect 密钥",
	"A location name is required. ": "位置名是必填的。 ",
	"A multi-tenant key management service. Create and manage cryptographic keys to encrypt data in your applications and control access to your data.": "多租户密钥管理服务。 创建和管理密钥以加密应用程序中的数据并控制数据访问。",
	"A name is required.": "名称是必填的。",
	"A rotation policy of 12 months is recommended": "建议实施 12 个月的轮换策略",
	"A service to service authorization is required between {{sourceServiceDisplayName}} and {{serviceDisplayName}} to associate the encryption key. Key Protect will create one with your consent. Or you can create one manually.": "{{sourceServiceDisplayName}} 与 {{serviceDisplayName}} 之间需要服务到服务授权，以便关联加密密钥。 Key Protect 将在征得您的同意后创建一个。 您也可以手动创建一个。",
	"A single-tenant key management service. Create and manage cryptographic keys with key vaulting that is provided by dedicated customer-controlled Hardware Security Module. ": "单租户密钥管理服务。 使用客户控制的专用硬件安全模块所提供的密钥保险库创建和管理密钥。 ",
	"A tag can include only alphanumeric characters, spaces, underscores, dashes, periods and one colon.": "标记只能包含字母数字字符、空格、下划线、短划线、句点和一个冒号。",
	"A tag cannot end with a colon.": "标记不能以冒号结尾。",
	"A tag cannot include more than 128 characters.": "标记包含的字符不能超过 128 个。",
	"A tag cannot start with a colon.": "标记不能以冒号开头。",
	"A tag should not have spaces around a colon.": "标记的冒号周围不应有空格。",
	About: About,
	Access: Access,
	"Access management tags": "访问权管理标记",
	"Access management tags (optional)": "访问管理标记（可选）",
	"Access management tags help you apply flexible access policies on specific resources.": "访问权管理标记有助于在特定资源上应用灵活的访问策略。",
	Account: Account,
	"Account type": "帐户类型",
	"Action required": "需要操作",
	Actions: Actions,
	Active: Active,
	"Active promotions": "活动促销",
	"Activity tracker event collection is enabled for this resource and sent to targets as defined by your routing configuration.": "已对该资源启用 Activity Tracker 事件收集，并且会根据您的路由配置的定义发送到目标。",
	"Activity tracker events": "活动跟踪程序事件",
	"Activity tracking": "活动跟踪",
	Add: Add,
	"Add a single namespace or multiple namespaces to your specific namespace's list.": "将单个名称空间或多个名称空间添加到特定名称空间的列表中。",
	"Add a single project or multiple projects to your specific project's list.": "将单个项目或多个项目添加到特定项目的列表中。",
	"Add Activity tracker event collection": "添加 Activity Tracker 事件收集",
	"Add activity tracking": "添加活动跟踪",
	"Add event collection": "添加事件收集",
	"Add hosts": "添加主机",
	"Add hosts to meet the minimum service requirements.": "添加主机以满足最低服务需求。",
	"Add key alias (optional)": "添加密钥别名（可选）",
	"Add key description (optional)": "添加密钥描述（可选）",
	"Add logging": "添加日志记录",
	"Add monitoring": "添加监视",
	"Add namespace": "添加名称空间",
	"Add New": "添加新项",
	"Add project": "添加项目",
	"Add storage": "添加存储",
	"Add tags": "添加标记",
	"Add to estimate": "添加到估算",
	"Add to existing": "添加到现有",
	"Add to project": "添加到项目",
	"Adding ...": "正在添加...",
	Address: Address,
	"Address any required actions below to successfully provision your service. You can complete these steps now, or after creating the service.": "处理以下任何必需操作以成功提供服务。 您可以立即完成这些步骤，也可以在创建服务之后完成。",
	"Address field": "地址字段",
	Advanced: Advanced,
	"Advanced options": "高级选项",
	"After connection": "连接后",
	"After the service cluster is created, assign storage to the cluster.": "创建服务集群后，将存储分配给集群。",
	"After you disconnect Event Notifications, the {{serviceName}} instance is removed from the list of source services in the Event Notifications instance.": "断开 Event Notifications 的连接后，将从 Event Notifications 实例中的源服务列表中移除 {{serviceName}} 实例。",
	Aliases: Aliases,
	"Aliases may only contain alphanumeric characters and -_.": "别名只能包含字母数字字符和 -_。",
	"Aliases must be at least 2 characters and at most 90 characters.": "别名必须至少包含 2 个字符，最多不超过 90 个字符。",
	all: all,
	All: All,
	"All audit events (default target)": "所有审计事件（缺省目标）",
	"All audit events from your account will be sent to a new instance": "您的帐户中的所有审计事件都将发送到新实例",
	"All audit events from your account will be sent to an existing instance": "您的帐户中的所有审计事件都将发送到现有实例",
	"All namespaces": "所有名称空间",
	"All namespaces not supported": "所有名称空间均不受支持",
	"All platform logs": "所有平台日志",
	"All prerequisite services are installed on the location.": "所有必备服务都安装在该位置上。",
	"All projects": "所有项目",
	"All projects not supported": "所有项目均不受支持",
	"All regions": "所有区域",
	"All resource groups": "所有资源组",
	"All secret groups": "所有私钥组",
	"All types": "全部类型",
	"All zone names must be unique": "所有专区名称都必须唯一",
	"Allowed actions for the {{roleName}} role ({{actionCount}})": "允许 {{roleName}} 角色执行的操作数（{{actionCount}} 个）",
	"Already have an account? <a>Log in</a>": "已有帐户？ <a>登录</a>",
	"An error occurred when fetching secrets. Try again later.": "访存私钥时发生错误。 请稍后重试。",
	"An instance of Event Notifications <a>Create new instance</a>": "Event Notifications 的实例 <a>创建新实例</a>",
	"An unexpected error occurred.": "发生意外错误。",
	"Analyze and manage logs for rapid issue resolution and proactive downtime prevention. <a>Learn more</a>": "分析和管理日志，以快速解决问题并主动预防停机。 <a>了解更多</a>",
	Apply: Apply,
	"Apply a code": "应用促销码",
	April: April,
	Arbitrary: Arbitrary,
	"Are you sure that you want to disconnect {{serviceName}} instance from the \"{{ENInstanceName}}\" instance?": "您确定要断开 {{serviceName}} 实例与“{{ENInstanceName}}”实例的连接吗？",
	"Are you sure you want to close the side panel?": "确定要关闭侧面板吗？",
	"Are you sure you want to close this panel? Any selections you have made will be lost.": "是否确定要关闭此面板？ 您所做的任何选择都将丢失。",
	"Are you sure?": "您确定吗？",
	Assign: Assign,
	"Associate key": "关联密钥",
	"Attachment name": "连接名称",
	"Audit event collection is already enabled for this resource": "已对该资源启用审计事件收集",
	"Audit event collection is recommended for optimal troubleshooting and reducing downtime": "建议启用审计事件收集，以获得最佳故障诊断和减少停机时间",
	"Audit events (error)": "审计事件（错误）",
	"Audit events from {{region}} will be sent to a new instance": "来自 {{region}} 的审计事件将发送到新实例",
	"Audit events from {{region}} will be sent to an existing instance": "来自 {{region}} 的审计事件将发送到现有实例",
	"Audit events in {{region}}": "{{region}} 中的审计事件",
	"Audit events will be collected from enabled IBM Cloud services according to the defined routing scope.": "将根据定义的路由作用域从启用的 IBM Cloud 服务中收集审计事件。",
	"Audit events...": "审计事件...",
	August: August,
	"Authentication is required or you do not have the correct permissions to perform this action.": "需要认证，或者您没有执行此操作的正确许可权。",
	"Authorization error": "授权错误",
	"Authorization met": "已满足授权要求",
	"Authorization needed": "需要授权",
	"Authorize now": "立即授权",
	"Authorizing...": "正在授权...",
	Back: Back,
	"Base URI": "基本 URI",
	"Base64 encoded key material": "采用 Base64 编码的密钥材料",
	Basic: Basic,
	"Before you begin": "准备工作",
	"Before your project can validate or deploy configurations, the Projects service needs to be authorized in this account to communicate with Schematics, Catalog Management, Secrets Manager, and Resource Controller. A user with the required access to those services can automatically grant authorizations by creating a project in this account, or they can create the service to service authorizations manually. This authorization is only required once.": "在项目可以验证或部署配置之前，需要在此帐户中授权“项目”服务与 Schematics、目录管理、Secrets Manager 和资源控制器进行通信。 具有这些服务的必需访问权的用户可以通过在此帐户中创建项目来自动授权，用户也可以手动创建服务到服务授权。 此授权只需要一次。",
	"Billing information": "帐单信息",
	"Billing period": "结算周期",
	BNPP_EU: BNPP_EU,
	"Bucket name": "存储区名称",
	"By {{name}}": "方式{{name}}",
	"By clicking Save, you are creating the following access:": "通过单击“保存”，您将创建以下访问权：",
	"Can't retrieve details": "无法检索详细信息",
	Cancel: Cancel,
	"Cannot list integrations!": "无法列出集成！",
	"Cannot view keys in this instance": "无法查看此实例中的密钥",
	Category: Category,
	"Charges apply. <a>Learn more</a>": "收取费用。 <a>了解更多</a>",
	"Choose a cluster version": "选择一个集群版本",
	"Choose a key ring": "选择密钥环",
	"Choose a resource group": "选择资源组",
	"Choose account...": "选择帐户...",
	"Choose an existing HPCS instance.": "选择现有的 HPCS 实例。",
	"Choose an existing Key Protect instance.": "选择现有 Key Protect 实例。",
	"Choose an instance": "选择实例",
	"Choose an option": "选择选项",
	"Choose category...": "选择类别...",
	"Choose location": "选择位置",
	"Choose plan": "选择套餐",
	"Choose property...": "选择属性...",
	"Choose provider...": "选择提供者...",
	"Choose secret...": "选择私钥...",
	"Choose service instance...": "选择服务实例...",
	"Choose source name...": "选择源名称...",
	"Choose source...": "选择源...",
	"Choose which IBM Cloud Monitoring instance will receive platform metrics from enabled service instances across IBM Cloud.": "选择将从 IBM Cloud 的已启用服务实例中接收平台度量值的 IBM Cloud Monitoring 实例。",
	"Choose which IBM Log Analysis instance will receive platform logs from enabled service instances across IBM Cloud.": "选择将从 IBM Cloud 的已启用服务实例中接收平台日志的 IBM Log Analysis 实例。",
	Classic: Classic,
	Clear: Clear,
	"Clear all": "全部清除",
	"Clear all selected items": "清除所有选定项",
	"Clear filters": "清除过滤器",
	"Clear selected": "清除所选项",
	"Clear selected item": "清除选定项",
	"Clear selection": "清除选项",
	CLI: CLI,
	Close: Close,
	"Close menu": "关闭菜单",
	"Close page navigation menu": "关闭页面导航菜单",
	"Close Panel": "关闭面板",
	"Close Push Panel": "关闭推送面板",
	"Closing side panel": "关闭侧面板",
	"Cloud Logs": "云日志",
	"Cloud Logs instance": "云日志实例",
	"Cloud Logs instance name": "云日志实例名称",
	"Cloud Object Storage": "Cloud Object Storage",
	"Cloud Object Storage instance": "Cloud Object Storage 实例",
	"Cluster \"{{name}}\" is being deleted.": "正在删除集群“{{name}}”。",
	"Cluster management": "集群管理",
	"Cluster version": "集群版本",
	"Cluster version cannot be updated.": "无法更新集群版本。",
	Clusters: Clusters,
	code: code,
	"Code sample": "代码样本",
	"Collapse all rows": "折叠所有行",
	"Collapse group": "折叠组",
	"Collapse row": "折叠行",
	"Collapse summary": "折叠摘要",
	"Compact (24px)": "精简（24 像素）",
	Complete: Complete,
	Completed: Completed,
	Compliance: Compliance,
	Compliant: Compliant,
	Configuration: Configuration,
	"Configuration details": "配置详细信息",
	"Configuration name": "配置名称",
	Configure: Configure,
	"Configure activity tracking": "配置活动跟踪",
	"Configure encryption": "配置加密",
	"Configure logging": "配置日志记录",
	"Configure monitoring": "配置监视",
	Confirm: Confirm,
	Connect: Connect,
	"Connect to Event Notifications": "连接到 Event Notifications",
	"Connect your {{serviceName}} instance to an existing Event Notifications instance.": "将您的 {{serviceName}} 实例连接到现有的 Event Notifications 实例。",
	Connected: Connected,
	"Connected instance": "已连接的实例",
	"Connected instance of Event Notifications does not exist. Contact your administrator.": "事件通知的已连接实例不存在。 请联系管理员。",
	Connecting: Connecting,
	"Contact your account administrator to access a plan to provision Key Protect.": "请与账户管理员联系，以便访问某个计划来配置 Key Protect。",
	"Contact your account administrator to access a resource group to provision Key Protect.": "请与账户管理员联系，以便访问资源组来配置 Key Protect。",
	"Contact your administrator for access.": "请联系管理员以获取访问权。",
	"Contact your administrator for additional assistance.": "联系管理员以获取更多帮助。",
	"Container registry": "Container Registry",
	Containers: Containers,
	"Copied to clipboard": "已复制到剪贴板",
	"Copy to clipboard": "复制到剪贴板",
	"Cost details": "成本详细信息",
	"costctr:124": "costctr:124",
	"Could not load pricing information. Refresh the page or try again later.": "无法装入定价信息。 请刷新页面或稍后重试。",
	Country: Country,
	Create: Create,
	"Create a key": "创建密钥",
	"Create a Logs routing target to support log management and analysis for rapid issue resolution and proactive downtime prevention. <a>Learn more</a>": "创建 Logs Routing 目标，以支持日志管理和分析，以快速解决问题并主动预防停机。 <a>了解更多</a>",
	"Create a new instance to get started.": "创建新实例以开始使用。",
	"Create a project": "创建项目",
	"Create a Satellite location to bring IBM Cloud anywhere. For more information, <a>see the documentation.</a>": "创建 Satellite 位置，以将 IBM Cloud 部署到任何位置。 有关更多信息，<a>请参阅文档</a>。",
	"Create an Activity tracker event routing target and route to support monitoring and auditing IBM Cloud activity for enhanced security and compliance. <a>Learn more</a>": "创建 Activity Tracker Event Routing 目标和路由，以支持监控和审计 IBM Cloud 活动，从而增强安全性和合规性。 <a>了解更多</a>",
	"Create an encryption key or import your own key.": "创建加密密钥或导入您自己的密钥。",
	"Create cluster": "创建集群",
	"Create failed": "创建失败",
	"Create instance": "创建实例",
	"Create location": "创建位置",
	"Create new": "新建",
	"Create new instance": "创建新实例",
	"Create new key": "创建新密钥",
	"Create new secret": "创建新私钥",
	"Create reference": "创建引用",
	"Create resource": "创建资源",
	"Create Satellite location": "创建 Satellite 位置",
	"Create secret": "创建私钥",
	"Create services": "创建服务",
	"Create Topics, Destinations and Subscriptions in Event Notifications to be notified of events that are generated by your {{serviceName}}": "在 Event Notifications 中创建主题、目标和预订，以便接收有关 {{serviceName}} 所生成事件的通知",
	Created: Created,
	Creating: Creating,
	"Creating ...": "正在创建...",
	"Creating...": "正在创建...",
	Critical: Critical,
	"CRON expression": "CRON 表达式",
	Current: Current,
	Custom: Custom,
	"Custom access": "定制访问权",
	Dallas: Dallas,
	"dashlet.title": "dashlet.title",
	Datacenter: Datacenter,
	Datacenters: Datacenters,
	"Datahook argument block": "Datahook 参数块",
	"Datahook Params": "Datahook 参数",
	"Datahook response": "Datahook 响应",
	"Day of month": "当月日期",
	"Day of Month (UTC)": "月中的日期 (UTC)",
	"Day of week": "一周中的某天",
	"Day of week (UTC)": "星期几 (UTC)",
	December: December,
	"Dedicated hosts": "专用主机",
	"Default target": "缺省目标",
	"Default title": "缺省标题",
	"Define project details": "定义项目详细信息",
	"Define the recurring timings of the events generated by this event. Select a predefined pattern and customize it to your needs. Schedules are specified in Coordinated Universal Time (UTC).": "定义此事件生成的事件的重现计时。 选择预定义模式并根据您的需要对其进行定制。 调度以全球标准时间 (UTC) 指定。",
	"Define the scope of audit events collected": "定义收集的审计事件的作用域",
	Delete: Delete,
	"Delete cluster": "删除集群",
	"Delete failed": "删除失败",
	"Delete retry wait": "删除重试等待",
	"Delete the persistent storage used by this cluster": "删除此集群使用的持久性存储器",
	Deleting: Deleting,
	"Deleting...": "正在删除...",
	"Deploy failed": "部署失败",
	"Deploy retry wait": "部署重试等待",
	Deploying: Deploying,
	"Deployment ready": "部署就绪",
	"Deprecated version, support will end {{when}}. Update the version to continue to receive support.": "不推荐的版本，支持将在 {{when}}结束。 请更新版本以继续接收支持。",
	"Description (optional)": "描述（可选）",
	"Description of the source": "源描述",
	Disabled: Disabled,
	Disconnect: Disconnect,
	"Disconnect Event Notifications": "断开 Event Notifications 的连接",
	"DNS subdomain labels must be no more than {{maxLength}} characters.": "DNS 子域标签的长度不得超过 {{maxLength}} 个字符。",
	Docs: Docs,
	Documentation: Documentation,
	Done: Done,
	"Done editing": "完成编辑",
	Download: Download,
	Draft: Draft,
	"During the update, your cluster master, worker nodes, apps, and resources continue to run. After the update is complete, you can update your worker node versions. For instructions and more information about differences across versions, <a>review the docs</a>.": "在更新期间，集群主节点、工作程序节点、应用程序和资源将继续运行。 更新完成后，可以更新工作程序节点版本。 有关不同版本之间差异的指示信息和更多信息，请<a>查看文档</a>。",
	Edit: Edit,
	"Edit activity tracker integration": "编辑 Activity Tracker 集成",
	"Edit Array": "编辑数组",
	"Edit columns": "编辑列",
	"Edit configuration": "编辑配置",
	"Edit details": "编辑详细信息",
	"Edit JSON": "编辑 JSON",
	"Edit logging integration": "编辑日志记录集成",
	"Edit secure value": "编辑安全值",
	"Edit tags": "编辑标记",
	"Enable lifecycle notifications for your {{serviceName}} instance by connecting an Event Notifications service instance.": "通过连接 Event Notifications 服务实例，为 {{serviceName}} 实例启用生命周期通知。",
	Enabled: Enabled,
	"Enables supervision, compliance, and audits the operations and risk to manage your IBM Cloud account.": "启用监管和合规性，并审计操作和风险以管理 IBM Cloud 帐户。",
	Encryption: Encryption,
	"Encryption key associated": "已关联加密密钥",
	"Encryption options menu": "加密选项菜单",
	End: End,
	"End date": "结束日期",
	"Enhance your Schematics experience with integrations. Start adding integrations today by selecting from one of the options below.": "通过集成可增强您的 Schematics 体验。 请立即通过选择下面其中一个选项开始添加集成。",
	"Enter a name for the configuration of the deployable architecture.  For example: production-vpc": "输入可部署体系结构的配置的名称。  例如：production-vpc",
	"Enter a password": "输入密码",
	"Enter a valid CRN": "输入有效的 CRN",
	"Enter array values. Quotations are added to values after you save.": "输入数组值。 保存后，会在值中添加报价。",
	"Enter name and description": "输入名称和描述",
	"Enter names for the host zones. For high availability, allocate your hosts across these three zones based on your infrastructure provider zones. <a>Why do I need zones?</a>": "输入主机专区的名称。 为了实现高可用性，请根据基础架构提供者专区在这三个专区中分配主机。 <a>为什么我需要专区？</a>",
	"Enter namespaces separated by a comma. After you click Add, the new namespaces are included in the list and automatically selected.": "输入多个名称空间并以逗号分隔。 单击“添加”后，新名称空间将包含在列表中并自动选中。",
	"Enter projects separated by a comma. After you click Add, the new projects are included in the list and automatically selected.": "输入多个项目并以逗号分隔。 单击“添加”后，新项目将包含在列表中并自动选中。",
	"Enter source name": "输入源名称",
	"Enter the exact name of an existing bucket in your Cloud Object Storage instance. If no name is provided, a new bucket is created for you.": "在 Cloud Object Storage 实例中输入现有存储区的准确名称。 如果未提供名称，将为您创建一个新存储区。",
	Enterprise: Enterprise,
	"Entire secret": "整个私钥",
	"Environment (optional)": "环境（可选）",
	"Environments can contain properties that are shared across related configurations. Within the configuration, you can override any values that are provided by the environment. <a>Learn more</a>": "环境可以包含在相关配置之间共享的属性。 在配置中，您可以覆盖环境提供的任何值。 <a>了解更多</a>",
	"Error": "错误",
	"Error checking existing services status": "检查现有服务状态时出错",
	"Error checking host status": "检查主机状态时出错",
	"Error checking storage status": "检查存储状态时出错",
	"Error fetching tags": "访存标记时出错",
	"Error icon": "“错误”图标",
	"Error loading accounts": "装入帐户时出错",
	"Error loading categories": "装入类别时出错",
	"Error loading groups": "装入组时出错",
	"Error loading instances": "装入实例时出错",
	"Error loading keys": "装入密钥时出错",
	"Error loading pricing": "装入定价时出错",
	"Error loading properties": "装入属性时出错",
	"Error loading providers": "装入提供程序时出错",
	"Error loading regions": "装入区域时出错",
	"Error loading resource groups": "装入资源组时出错",
	"Error loading S2S auth": "装入 S2S 认证时出错",
	"Error loading secrets": "装入私钥时出错",
	"Error loading source names": "装入源名称时出错",
	"Error loading sources": "装入源时出错",
	"Error loading types": "装入类型时出错",
	"Error validating this code. Please make sure you don't include any quotation marks in the promo code.": "验证此代码时出错。 请确保促销代码中不包含任何引号。",
	Establish: Establish,
	"Estimate costs": "估算成本",
	"Estimated cost per instance": "每个实例的估算成本",
	"Estimated starting cost": "估算的起始成本",
	"Estimated total ({{count}} instances)": "估算总计（{{count}} 个实例）",
	"Event Notifications": "Event Notifications",
	"Event Notifications instance": "Event Notifications 实例",
	"Event Notifications service instance": "Event Notifications 服务实例",
	"Event Source Manager": "事件源管理器",
	"Every 2 hours": "每隔 2 小时",
	"Every 2 minutes": "每 2 分钟",
	"Every 3 hours": "每 3 小时",
	"Every 4 hours": "每隔 4 小时",
	"Every 5 minutes": "每 5 分钟",
	"Every 6 hours": "每 6 小时",
	"Every 10 minutes": "每 10 分钟",
	"Every 15 minutes": "每隔 15 分钟",
	"Every day": "每天",
	"Every fifth day": "每隔四天",
	"Every fourth day": "每隔三天",
	"Every fourth month": "每 4 个月",
	"Every hour": "每小时",
	"Every minute": "每分钟",
	"Every month": "每月",
	"Every second day": "每隔一天",
	"Every second month": "每 2 个月",
	"Every sixth month": "每 6 个月",
	"Every third day": "每隔两天",
	"Every third month": "每 3 个月",
	"Examples: access:dev, proj:version-1": "示例：access:dev, proj:version-1",
	"Examples: env:dev, version-1": "示例：env:dev, version-1",
	"Existing instance": "现有实例",
	"Exiting encryption selection": "正在退出加密选择",
	"Expand all rows": "展开所有行",
	"Expand group": "展开组",
	"Expand row": "展开行",
	"Expand summary": "展开摘要",
	Expired: Expired,
	"Expired (beta)": "已到期 (beta)",
	"Expires {{when}}": "到期时间：{{when}}",
	"Expires after beta": "在 Beta 后到期",
	"Extra large (64px)": "超大 (64px)",
	"Extra small (24px)": "超小 (24px)",
	Failed: Failed,
	"Failed to check permission": "无法检查许可权",
	"Failed to create configuration": "无法创建配置",
	"Failed to create key": "无法创建密钥。",
	"Failed to create policy": "未能创建策略",
	"Failed to create project": "无法创建项目",
	"Failed to fetch": "访存失败",
	"Failed to fetch IBM Cloud Activity Tracker instances.": "未能访存 IBM Cloud Activity Tracker 实例。",
	"Failed to fetch IBM Cloud Monitoring instances.": "未能访存 IBM Cloud Monitoring 实例。",
	"Failed to fetch IBM Log Analysis instances.": "未能访存 IBM Log Analysis 实例。",
	"failure state": "故障状态",
	February: February,
	"Fetch data": "访存数据",
	Filter: Filter,
	"Filter instance by region": "按区域过滤实例",
	"Filter...": "过滤器...",
	Filters: Filters,
	"Filters:": "过滤器：",
	Finalizing: Finalizing,
	"Finalizing cluster...": "正在完成集群 ...",
	"Finalizing workers...": "正在完成工作程序...",
	Frankfurt: Frankfurt,
	Free: Free,
	Friday: Friday,
	Geography: Geography,
	"Get operational visibility into your Cloud resources with IBM Cloud Activity Tracker.": "使用 IBM Cloud Activity Tracker 了解云资源的操作情况。",
	"Get operational visibility into your Cloud resources with IBM Cloud Monitoring.": "使用 IBM Cloud Monitoring 了解云资源的操作情况。",
	"Get operational visibility into your Cloud resources with IBM Log Analysis.": "使用 IBM Log Analysis 了解云资源的操作情况。",
	"Get started": "开始",
	"Get started with Security and Compliance Center": "Security and Compliance Center 入门",
	"Give your key an alias for easy retrieval later.": "为密钥提供别名，方便以后检索。",
	"Helm catalog": "Helm 目录",
	Help: Help,
	"Hide password": "隐藏密码",
	"Host usage\n(used / total)": "主机使用情况（已使用/总计）",
	"Hosts needed": "需要的主机",
	"Hosts requirements met": "已满足主机需求",
	hour: hour,
	Hour: Hour,
	"Hour (UTC)": "小时 (UTC)",
	hr: hr,
	"Hyper Protect Crypto Services": "Hyper Protect Crypto Services",
	"I agree to use my token to create a service to service policy between source service {{sourceServiceDisplayName}} and target service {{serviceDisplayName}} on my behalf.": "我同意使用我的令牌代表我在源服务 {{sourceServiceDisplayName}} 与目标服务 {{serviceDisplayName}} 之间创建服务到服务策略。",
	"I confirm that I want to stop receiving platform logs from {{instance}}": "我确认要停止从 {{instance}} 接收平台日志",
	"I confirm that I want to stop receiving platform metrics from {{instance}}": "我确认要停止从 {{instance}} 接收平台度量值",
	"IaaS ready": "IaaS 已就绪",
	IAM: IAM,
	"IAM credentials": "IAM 凭证",
	"IBM Cloud": "IBM Cloud",
	"IBM Cloud Activity Tracker": "IBM Cloud Activity Tracker",
	"IBM Cloud Monitoring": "IBM Cloud Monitoring",
	"IBM Cloud Satellite": "IBM Cloud Satellite",
	"IBM Log Analysis": "IBM Log Analysis",
	ID: ID,
	"ID: {{incidentId}}": "标识：{{incidentId}}",
	"If no key ring is assigned, key will be added to the default key ring.": "如果未指定密钥环，那么会将密钥添加到缺省密钥环。",
	"If selected, the array will be saved as \"__NOT_SET__\" string.": "如果选择此选项，那么数组将另存为“__NOT_SET__”字符串。",
	"If the initial value was not a valid string array, an empty or single item array will appear below.": "如果初始值不是有效的字符串数组，那么以下将显示空数组或单项数组。",
	"If your user tags are billing related, consider writing tags as key:value pairs, such as": "如果用户标记与计费相关，请考虑将标记写成“键:值”对，例如",
	Images: Images,
	"Import your own key": "导入您拥有的密钥",
	"In progress": "进行中",
	"in progress state": "进行中状态",
	Inactive: Inactive,
	"inactive state": "不活动状态",
	Incomplete: Incomplete,
	"incomplete state": "不完整状态",
	Information: Information,
	"information state": "信息状态",
	Infrastructure: Infrastructure,
	"Infrastructure zones": "基础架构区域",
	Instance: Instance,
	"Instance ID": "实例标识",
	"Instance location": "实例位置",
	"Instance name": "实例名称",
	"Instance(s) in {{region}}": "{{region}} 中的实例",
	"Instance(s) in region": "区域中的实例",
	Instances: Instances,
	Integrations: Integrations,
	"Internal server error. Wait a minute and try your action again. If the issue persists, open a support ticket.": "内部服务器错误。 请稍候，然后重试您的操作。 如果问题仍然存在，请开具支持凭单。",
	"Interpolated URI": "插值 URI",
	Invalid: Invalid,
	"Invalid datahook object, using last valid options": "使用最后一个有效选项的 Datahook 对象无效",
	"Invalid label name.": "标签名称无效。",
	"Invalid label prefix or name.": "标签前缀或名称无效。",
	"Invalid label value.": "标签值无效。",
	"Items per page:": "每页项数：",
	January: January,
	July: July,
	June: June,
	Key: Key,
	"Key aliases": "密钥别名",
	"Key CRN": "密钥 CRN",
	"Key description": "密钥描述",
	"Key description must be at least 2 characters and no more than 240 characters.": "密钥描述至少应为 2 个字符且不超过 240 个字符。",
	"Key ID": "密钥标识",
	"Key management": "密钥管理",
	"Key management service": "密钥管理服务",
	"Key material": "密钥资料",
	"Key material is required to import a key": "导入密钥时需要密钥材料",
	"Key material length must be 128, 192, or 256 bits": "密钥材料长度必须为 128、192 或 256 位",
	"Key material must be base64": "密钥材料必须采用 base64 编码",
	"Key name": "密钥名称",
	"Key Protect": "Key Protect",
	"Key Protect instance name": "Key Protect 实例名称",
	"Key ring": "密钥环",
	"Key value": "密钥值",
	"Label must be of the form 'key:value'.": "标签的格式必须为 \"key:value\"。",
	"Label name must be no more than {{maxLength}} characters.": "标签名称的长度不得超过 {{maxLength}} 个字符。",
	"Label prefix must be a valid DNS subdomain.": "标签前缀必须是有效的 DNS 子域。",
	"Label prefix must be no more than {{maxLength}} characters.": "标签前缀的长度不得超过 {{maxLength}} 个字符。",
	"Label value must be no more than {{maxLength}} characters.": "标签值的长度不得超过 {{maxLength}} 个字符。",
	"Large (48px)": "大 (48px)",
	"Last modified": "上次修改时间",
	"Last scanned": "上次扫描时间",
	"Last updated": "上次更新时间",
	Launch: Launch,
	"Launch activiting tracking": "启动活动跟踪",
	"Launch in new window": "在新窗口中启动",
	"Launch logging": "启动日志记录",
	"Launch monitoring": "启动监视",
	"Learn more": "了解更多",
	"learn more.": "了解更多信息。",
	"Learn more.": "了解更多信息。",
	"List of actions": "操作列表",
	"list of code sample types": "代码样本类型列表",
	Lite: Lite,
	Loading: Loading,
	"Loading indicator": "正在装入指示器",
	"Loading...": "正在装入...",
	"Locate by CRN within your account": "在您的帐户中按 CRN 查找",
	Location: Location,
	"Location summary": "位置摘要",
	"Location:": "位置：",
	Locations: Locations,
	"Log collection is already enabled for this resource": "已对该资源启用日志收集",
	"Log collection is enabled for this resource and sent to targets as defined by your routing configuration.": "已对该资源启用日志收集，并且会根据您的路由配置的定义发送到目标。",
	Logging: Logging,
	"Logging (error)": "日志记录（错误）",
	"Logging is recommended for optimal troubleshooting and reducing downtime": "建议启用日志记录，以获得最佳故障诊断和减少停机时间",
	"Logging...": "正在进行日志记录...",
	London: London,
	"Looking for valid service to service authorization policy...": "正在查找有效的服务到服务授权策略...",
	"Looks like you are missing the required permissions to create the policy. Contact your account administrator": "您似乎缺少创建策略时所需的许可权。 联系您的帐户管理员",
	"Looks like you don't have access to view account information.": "您似乎无权查看帐户信息。",
	"Looks like you don't have access to view the billing period": "您似乎无权查看结算周期",
	"Looks like you don't have any scans": "您似乎没有任何扫描",
	"Looks like you don't have the access needed to view this information. Contact your account administrator to verify your permissions.": "您似乎没有查看此信息所需的访问权。 请与帐户管理员联系，以验证您的许可权。",
	"Looks like you don't have the correct access": "您似乎没有正确的访问权限",
	"Looks like you don't have the correct access. You must have access to the target service to create an authorization between services.": "似乎您没有正确的访问权。 您必须有权访问目标服务，才能在服务之间创建授权。",
	"Make sure you have Topics, Subscriptions and Destinations setup in Event Notifications.": "确保在 Event Notifications 中设置了“主题”、“预订”和“目标”。",
	"Manage encryption by enabling a key management service (KMS).": "通过启用密钥管理服务 (KMS) 来管理加密。",
	"Manage routing": "管理路由",
	"Manage the lifecycle of your encryption keys that are used for you IBM Cloud resources, services, and applications.": "管理用于 IBM Cloud 资源、服务和应用程序的加密密钥的生命周期。",
	"Managed from": "管理位置",
	March: March,
	May: May,
	"Media gallery video": "媒体库视频",
	"Medium (40px)": "中 (40px)",
	"Metadata location": "元数据位置",
	Metro: Metro,
	"Minimum host requirements are met.": "已满足最低主机需求。",
	Minute: Minute,
	"Minute (UTC)": "分钟 (UTC)",
	"Missing prerequisite services": "缺少必备服务",
	mo: mo,
	"Modify the arguments passed into your datahook here.": "在此处修改已传递到 Datahook 的参数。",
	"Mon-Fri": "周一至周五",
	Monday: Monday,
	"Monitor all of your environments for compliance by setting up scans.": "通过设置扫描来监控所有环境的合规性。",
	"Monitor and audit IBM Cloud activity for enhanced security and compliance. <a>Learn more</a>": "监控和审计 IBM Cloud 活动，以增强安全性和合规性。 <a>了解更多</a>",
	Monitoring: Monitoring,
	Month: Month,
	"Month (UTC)": "月份 (UTC)",
	more: more,
	Name: Name,
	"Name already in use. Provide a unique name.": "名称已在使用中。 提供唯一名称。",
	"Name must be between 2 and 90 characters": "必须在 2 至 90 个字符之间",
	"Name this project": "命名此项目",
	Namespace: Namespace,
	Namespaces: Namespaces,
	"New instance": "新建实例",
	Next: Next,
	"Next page": "下一页",
	"Next: Customize": "下一步：定制",
	"nmpc-1, namespc-2": "nmpc-1, namespc-2",
	No: No,
	"No available catalog regions": "无可用目录区域",
	"No Cloud Object Storage instance is available.": "未提供 Cloud Object Storage 实例。",
	"No code preview has been configured for terraform. Please visit our docs to ": "没有为 Terraform 配置任何代码预览。 请访问我们的文档 ",
	"No configurations available": "没有可用的配置",
	"No events can be scheduled with your selected CRON expression.": "无法使用所选 CRON 表达式调度任何事件。",
	"No Hyper Protect Crypto Services instances found": "未找到 Hyper Protect Crypto Services 实例",
	"No instances found": "找不到实例",
	"No item matches the filters. Clear the filters and try again.": "没有匹配过滤器的项。 请清除过滤器，然后重试。",
	"No items available to display. Select an instance and bucket to view objects.": "没有可显示的项。 选择实例和存储区以查看对象。",
	"No items match the current filter.": "没有项与当前过滤器匹配。",
	"No keys available": "没有可用的密钥",
	"No matches found. To create new tags, contact your tag administrator.": "找不到匹配项。 要创建新标记，请与标记管理员联系。",
	"No matching options": "无匹配选项",
	"No matching region ID's are available on this account. If you think this is an error, refresh the page or contact your administrator.": "此帐户没有可用的匹配区域标识。 如果您认为这是错误，请刷新页面或与管理员联系。",
	"No plans found": "未找到任何计划",
	"No regions available": "没有可用的区域",
	"No resource groups available": "没有可用的资源组",
	"No secret available": "没有可用的私钥",
	"No secret group available": "没有可用的私钥组",
	"No service instance available": "没有可用的服务实例",
	"No valid version update options are available.": "没有可用的有效版本更新选项。",
	"Non-compliant": "不合规",
	None: None,
	"None available": "没有内容可用",
	Normal: Normal,
	"Normal (48px)": "正常（48 像素）",
	"Not authorized": "未授权",
	"Not ready": "未就绪",
	Note: Note,
	Notification: Notification,
	November: November,
	"Object": "对象",
	"Object storage": "对象存储器",
	"Object storage is used to store data about your location and backups for your location's clusters. <a>Learn more.</a>": "Object Storage 用于存储有关位置的数据以及位置集群的备份。 <a>了解更多信息。</a>",
	Objects: Objects,
	October: October,
	Off: Off,
	OK: OK,
	On: On,
	"Once a day": "每天一次",
	"Once a month": "每月一次",
	"Once a week": "每周一次",
	"Once a year": "一年一次",
	Open: Open,
	"Open dashboard": "打开仪表板",
	"Open Dashboard": "打开仪表板",
	"Open menu": "打开菜单",
	"Open page navigation menu": "打开页面导航菜单",
	"Open reference picker": "打开引用选取器",
	"Open tab list": "打开选项卡列表",
	Osaka: Osaka,
	"Overflow menu": "溢出菜单",
	"Overflow Menu": "溢出菜单",
	Overview: Overview,
	Packages: Packages,
	"page {{pageNumber}}": "第 {{pageNumber}} 页",
	"Page Navigation": "页面导航",
	"Page navigation menu": "页面导航菜单",
	"Page number": "页码",
	Pattern: Pattern,
	"Pay-As-You-Go": "现收现付",
	Pending: Pending,
	Plan: Plan,
	"Platform access": "平台访问权",
	"Platform logs from {{region}} will be sent to a new instance": "来自 {{region}} 的平台日志将发送到新实例",
	"Platform logs from {{region}} will be sent to an existing instance": "来自 {{region}} 的平台日志将发送到现有实例",
	"Platform logs from {{region}} will be sent to the target instance. <a>Learn more</a>": "来自 {{region}} 的平台日志将发送到目标实例。 <a>了解更多</a>",
	"Platform logs will be collected from enabled IBM Cloud services according to the defined routing scope.": "将根据定义的路由作用域从启用的 IBM Cloud 服务中收集平台日志。",
	"Please <a>sign up</a> to create or <a>login</a> before applying the promo code.": "在应用促销代码之前，请<a>注册</a>以创建或<a>登录</a> 。",
	"Prefix filter": "前缀过滤器",
	Premium: Premium,
	"Preparing master, workers...": "正在准备主工作程序...",
	"Preparing master...": "正在准备主工作程序...",
	"Prerequisite services installed": "已安装必备服务",
	Previous: Previous,
	"Previous page": "上一页",
	"Pricing Plans": "定价计划",
	"prj-1, projct-2": "prj-1, projct-2",
	Product: Product,
	Products: Products,
	Project: Project,
	Projects: Projects,
	Property: Property,
	"Provide a more detailed description of the key. To protect your privacy, do not use personal data, such as your name or location, as a description. You cannot change this after key creation.": "提供更详细的密钥描述。 为保护您的隐私，请勿使用个人数据（例如您的姓名或位置）作为描述。 创建密钥后无法更改此内容。",
	provided: provided,
	Provider: Provider,
	"Provides visibility of the performance and health of your IBM Cloud powered resources application.": "提供 IBM Cloud 驱动的资源应用程序的性能和运行状况的可视性。",
	Provisioning: Provisioning,
	Ready: Ready,
	"Ready to apply?": "准备好应用了吗？",
	Refresh: Refresh,
	"Refresh Cloud Object Storage instances": "刷新 Cloud Object Storage 实例",
	"Refresh data": "刷新数据",
	"Refresh secrets": "刷新私钥",
	region: region,
	Region: Region,
	Remove: Remove,
	"Remove sort": "除去排序",
	"Rendering modify hooks is not supported to prevent unexpected resource changes.": "不支持呈现修改挂钩，以防止发生意外的资源更改。",
	Renew: Renew,
	Repositories: Repositories,
	Requested: Requested,
	"Requesting creation...": "正在请求创建...",
	Required: Required,
	Reservations: Reservations,
	Reset: Reset,
	"Reset filters": "重置过滤器",
	"Reset to default": "重置为缺省值",
	"Reset zoom": "重置缩放",
	"Resource Configuration": "资源配置",
	"Resource group": "资源组",
	"Resource group:": "资源组：",
	"Resource list": "资源列表",
	"Resource List": "资源列表",
	resources: resources,
	Resources: Resources,
	"Resources not included in cost": "未列入成本的资源",
	"Restricted access": "受限访问权",
	Results: Results,
	"Retrying delete": "正在重试删除",
	"Retrying deploy": "正在重试部署",
	"Revert {{resetCount}} to default": "将 {{resetCount}} 还原为缺省值",
	Review: Review,
	"Review access assignments to {{resourceDisplayName}}": "复查对 {{resourceDisplayName}} 的访问权分配",
	"Review settings in Event Notifications": "复审 Event Notifications 中的设置",
	"Review the following access group policies to ensure you're assigning the right level of access.": "复查以下访问组策略，以确保分配了正确的访问级别。",
	"Rotation interval": "轮换时间间隔",
	"Rotation policies determine the interval between automatic key rotations. An interval of one month, for example, means that a key will be rotated every 30 days. If the policy is already enabled, this means that an instance policy exists for this instance and if no other action is taken, the rotation interval shown will be applied to the key. If it is disabled, enable it to set a policy for this key.": "轮换策略用于确定自动密钥轮换之间的时间间隔。 例如，间隔 1 个月意味着将每 30 天轮换一次密钥。 如果已启用该策略，那么这意味着此实例存在实例策略，如果未执行其他操作，那么所显示的轮换时间间隔将应用于此密钥。 如果已禁用，请使其能够为此密钥设置策略。",
	"Rotation policy": "轮换策略",
	"Rotation policy disabled": "已禁用轮换策略",
	"Route name": "路由名称",
	Routing: Routing,
	"Routing scope": "路由作用域",
	"Row height": "行高",
	"Sample not yet available": "样本尚不可用",
	"Sao Paulo": "圣保罗州",
	"Sat-Sun": "周六至周日",
	Satellite: Satellite,
	"Satellite container": "Satellite 容器",
	"Satellite location": "Satellite 位置",
	"Satellite location base cost": "Satellite 位置基本成本",
	"Satellite location base functionality": "Satellite 位置基本功能",
	Saturday: Saturday,
	Save: Save,
	"Saving...": "正在保存...",
	Scanning: Scanning,
	Schedule: Schedule,
	"Schematics workspaces and other project data are stored in the selected region and resource group. <a>Learn more.</a>": "Schematics 工作空间和其他项目数据存储在所选区域和资源组中。 <a>了解更多信息。</a>",
	"Schematics workspaces are provisioned in this region. Your project can still deploy resources to any region.": "在此区域中供应 Schematics 工作空间。 您的项目仍可以将资源部署到任何区域。",
	"Schematics workspaces are provisioned in this resource group. Your project can still deploy resources to any resource group.": "在此资源组中供应 Schematics 工作空间。 您的项目仍可以将资源部署到任何资源组。",
	Search: Search,
	"Search in this instance": "在该实例中搜索",
	Secret: Secret,
	"Secret configured": "已配置私钥",
	"Secret group": "私钥组",
	"Secret type": "私钥类型",
	"Secrets Manager": "Secrets Manager",
	"Secure value": "安全值",
	"See details": "查看详细信息",
	Select: Select,
	"Select a location to see what steps you need to take next.": "选择一个位置以查看接下来需要采取的步骤。",
	"Select a project": "选择项目",
	"Select a reference": "选择引用",
	"Select a region": "选择区域",
	"Select a resource group": "选择资源组",
	"Select a role to determine the level of access for the source service.": "选择角色以确定对源服务的访问级别。",
	"Select a secret": "选择私钥",
	"Select a secret group": "选择私钥组",
	"Select a service instance": "选择服务实例",
	"Select all {{totalRowCount}} items": "选择所有 {{totalRowCount}} 项",
	"Select all rows on page": "选择页面上的所有行",
	"Select an environment": "选择环境",
	"Select an existing configuration": "选择现有配置",
	"Select an IBM Cloud Monitoring instance to receive platform metrics": "选择要接收平台度量值的 IBM Cloud Monitoring 实例",
	"Select an IBM Log Analysis instance to receive platform logs": "选择要接收平台日志的 IBM Log Analysis 实例",
	"Select an instance": "选择实例",
	"Select an instance to show keys": "选择要显示密钥的实例",
	"Select an option...": "选择一个选项...",
	"Select existing key": "选择现有密钥",
	"Select from Secrets Manager": "从 Secrets Manager 中进行选择",
	"Select KMS instance": "选择 KMS 实例",
	"Select namespaces": "选择名称空间",
	"Select one or more namespaces": "选择一个或多个名称空间",
	"Select one or more projects": "选择一个或多个项目",
	"Select prerequisites": "选择先决条件",
	"Select projects": "选择项目",
	"Select region and resource group": "选择区域和资源组",
	"Select row": "选择行",
	"Select the <a>IBM Cloud region</a> that is closest to where your infrastructure resides to ensure low network latency.": "选择最接近基础架构所在位置的 <a>IBM Cloud 区域</a>，以确保网络延迟较低。",
	"Select the following tile to deploy it.": "选择以下磁贴进行部署。",
	"Send all audit events from enabled resources in {{region}}.": "从 {{region}} 中启用的资源发送所有审计事件。",
	"Send all available audit events in this account.": "发送此帐户中所有可用的审计事件。",
	"Send events to": "将事件发送至",
	"Send logs to": "将日志发送至",
	"Send test notification": "发送测试通知",
	Sending: Sending,
	"Sent!": "已发送！",
	September: September,
	Serverless: Serverless,
	"Serverless projects": "无服务器项目",
	Service: Service,
	"Service access": "服务访问权",
	"Service authorization": "服务授权",
	"Service authorization is required to allow Activity Tracker Event Routing to communicate with Cloud Logs. Click <span>Authorize now</span> to create a policy scoped to all Cloud Logs resources in this account.": "需要服务授权才能允许 Activity Tracker Event Routing 与 Cloud Logs 通信。 单击<span>立即授权</span>以创建作用域限定为此帐户中所有 Cloud Logs 资源的策略。",
	"Service authorization required": "需要服务授权",
	"Service instance": "服务实例",
	"Service name": "服务名称",
	"Service to service authorization must be provided for your instance. <a>Learn more</a>": "必须提供您的实例的服务间授权。 <a>了解更多</a>",
	"Service to service authorization policy found": "已找到服务到服务授权策略",
	"Service to service authorization policy needed": "需要服务到服务授权策略",
	"Service type": "服务类型",
	"Service-to-service authorization couldn't be verified. Manually add and check the required roles.": "无法验证服务到服务授权。 手动添加并检查所需角色。",
	"Service-to-service authorization requirements are met.": "已满足服务到服务授权需求。",
	"Set an interval (in months)": "设置时间间隔（以月计）",
	"Set key rotation policy": "设置密钥轮换策略",
	"Set up auth": "设置认证",
	Settings: Settings,
	"Short (32px)": "矮（32 像素）",
	"Show all filters": "显示所有过滤器",
	"Show code sample": "显示代码样本",
	"Show environments information": "显示环境信息",
	"Show error information": "显示错误信息",
	"Show information": "显示信息",
	"Show less": "显示更少",
	"Show more": "显示更多",
	"Show more details": "显示更多详细信息",
	"Show password": "显示密码",
	"Show tooltip": "显示工具提示",
	"Showing {{count}} item": "正在显示 {{count}} 项",
	"Showing {{count}} items": "正在显示 {{count}} 项",
	Size: Size,
	"Small (32px)": "小 (32px)",
	"Some events from {{serviceName}}:": "来自 {{serviceName}} 的一些事件：",
	"Something went wrong": "出错了！",
	"Something went wrong.": "发生错误。",
	"Something went wrong. Try reloading the page to see this information": "发生错误。 请尝试重新装入页面以查看此信息",
	Sort: Sort,
	"Sort ascending": "升序排序",
	"Sort descending": "降序排序",
	Source: Source,
	"Source Details": "源详细信息",
	"Source for the service does not exist in Event Notifications instance. Contact your administrator.": "事件通知实例中不存在服务源。 请联系管理员。",
	"Source service": "源服务",
	"Specific namespaces not supported": "不支持特定名称空间",
	"Specific projects not supported": "不支持特定项目",
	Start: Start,
	"Start by creating a cluster that is just right to run your workloads.": "首先创建一个正好适合运行您的工作负载的集群。",
	"Start date": "开始日期",
	"Starting at": "起始于",
	"Starting costs are based on this resource configuration. You can edit configurations after you add this product to a project, which might impact costs.": "启动成本基于此资源配置。 您可以在将该产品添加到项目后编辑配置，这可能会影响成本。",
	State: State,
	Status: Status,
	"status icon": "状态图标",
	"Stay in pattern": "保持模式",
	"Steps complete": "步骤完成",
	Storage: Storage,
	"Storage bucket (optional)": "存储区（可选）",
	"Storage configuration missing": "缺少存储配置",
	"Storage ready": "存储已就绪",
	"Store, search, analyze, monitor, and alert on your IBM Cloud logging data and events.": "存储、搜索、分析、监视和警告 IBM Cloud 日志记录数据和事件。",
	Submit: Submit,
	Subscription: Subscription,
	Success: Success,
	"success state": "成功状态",
	"Success! This promotion was applied to your account.": "成功！ 此促销已应用于您的帐户。",
	"Successfully created new Key Protect instance": "已成功创建新的 Key Protect 实例",
	Summary: Summary,
	Sunday: Sunday,
	"Support Plan": "支持套餐",
	"Switch to folders view": "切换到文件夹视图",
	"Switch to objects view": "切换到对象视图",
	Sydney: Sydney,
	"Syntax: ": "语法： ",
	tag: tag,
	"Tag '{{tagName}}' could not be created as the name is invalid.": "无法创建标记“{{tagName}}”，因为该名称无效。",
	tags: tags,
	Tags: Tags,
	"Tags:": "标记：",
	"Tags: (optional)": "标记：（可选）",
	"Tall (64px)": "高（64 像素）",
	"Target destination": "目标",
	"Target location": "目标位置",
	"Target name": "目标名称",
	"Target selected": "目标已选定",
	"Target service instance": "目标服务实例",
	"Target type": "目标类型",
	"Template error": "模板错误",
	"Terms and conditions": "条款和条件",
	"Test notification": "测试通知",
	"The address field is required.": "地址字段是必填字段。",
	"The catalog window might have been blocked from opening.": "目录窗口可能已被阻止打开。",
	"The connected Event Notifications instance was deleted from the account. To continue using notifications, disconnect the current instance by clicking Disconnect from the menu ( ⋮ ). Then, connect another Event Notifications instance.": "已从帐户中删除已连接的 Event Notifications 实例。 要继续使用通知，请通过单击菜单 ( ⋮ ) 中的“断开连接”来断开当前实例的连接。然后，连接另一个 Event Notifications 实例。",
	"The description should not contain any leading or trailing whitespace characters.": "描述不应包含任何前导或尾部空格字符。",
	"The description should not exceed {{limit}} characters in length.": "描述长度不应超过 {{limit}} 个字符。",
	"The following access is required:": "需要以下访问权限:",
	"The following code preview displays the corresponding request as CLI commands. Use it as a starting point for writing your own automation. ": "以下代码预览将相应的请求显示为 CLI 命令。 可以将它用作编写自己的自动化的起点。 ",
	"The following code preview displays the corresponding request as REST API calls. Use it as a starting point for writing your own automation. ": "以下代码预览将相应的请求显示为 REST API 调用。 可以将它用作编写自己的自动化的起点。 ",
	"The following code preview displays the corresponding request with Terraform. Use it as a starting point for writing your own automation. ": "以下代码预览显示具有 Terraform 的相应请求。 可以将它用作编写自己的自动化的起点。 ",
	"The following preview displays the corresponding request as code. Use it as a starting point for writing your own automation.": "以下预览将相应的请求显示为代码。 可以将它用作编写自己的自动化的起点。",
	"The following resources were not included in the cost estimate but might have an associated cost.": "以下资源未包含在估算成本中，但可能产生相关成本。",
	"The IAM role manager for {{serviceName}}": "{{serviceName}} 的 IAM 角色管理器",
	"The instance can't be accessed because a service to service authorization was removed from the account. Create an authorization with Event Source Manager access between {{sourceServiceName}} and Event Notifications.": "无法访问该实例，因为已从帐户中移除服务间授权。 在 {{sourceServiceName}} 与 Event Notifications 之间创建具有事件源管理器访问权限的授权。",
	"The list of namespaces can't be populated. Try again later.": "无法填充名称空间列表。 请稍后重试。",
	"The list of projects can't be populated. Try again later.": "无法填充项目列表。 请稍后重试。",
	"The name is required.": "需要该名称。",
	"The name must be {{max}} or fewer characters, begin with a letter, and contain only alphanumeric characters, '-', and '.'": "名称长度必须为 {{max}} 个或更少字符，以字母开头，且仅包含字母数字字符、“-”和“.”",
	"The name of a namespace can include only lowercase letters, numbers, and dashes. The name can't start or end with a dash, and it must be at a maximum of 63 characters.": "名称空间的名称只能包含小写字母、数字和短划线。 该名称不能以短划线开头或结尾，且不得超过 63 个字符。",
	"The name of a project can include only lowercase letters, numbers, and dashes. The name can't start or end with a dash, and it must be at a maximum of 63 characters.": "项目的名称只能包含小写字母、数字和短划线。 该名称不能以短划线开头或结尾，且不得超过 63 个字符。",
	"The name should contain only alphanumeric, underscore, dashes and space.": "名称应仅包含字母数字、下划线、短划线和空格。",
	"The name should not contain any special characters.": "名称不应包含任何特殊字符。",
	"The name should not exceed {{limit}} characters in length.": "名称长度不应超过 {{limit}} 个字符。",
	"The region is required.": "区域是必需的。",
	"The resource group is required.": "资源组是必需的。",
	"The resource group window might have been blocked from opening.": "可能已阻止打开资源组窗口。",
	"The tag name must be in a key:value format": "标记名称必须为“键:值”格式",
	"The tag name must be in a key:value format.": "标记名称必须采用 key:value 格式。",
	"The window might have been blocked from opening.": "可能已阻止打开该窗口。",
	"There was a problem loading resource groups.": "装入资源组时出现问题。",
	"These roles allow access for using the service and performing service API calls. Each role is customized by the selected service. Select all that apply. Refer to the service's documentation for more details.": "这些角色允许有权使用服务和执行服务 API 调用。 每个角色由所选服务进行定制。 选择适用的所有角色。 请参阅服务的文档以获取更多详细信息。",
	"These roles are created by administrators in the account to customize how access is assigned to the service. Click the Actions for role icon to review what actions are mapped to this role.": "这些角色由管理员在帐户中创建，以定制如何分配对服务的访问权。 单击“角色的操作”图标以查看哪些操作映射到此角色。",
	"These roles enable actions to be performed on platform resources, such as creating an instance, connecting instances to apps, and assigning user access. Select all that apply.": "这些角色支持对平台资源执行操作，例如创建实例、将实例连接到应用程序和分配用户访问权。 选择适用的所有角色。",
	"This field is required": "此字段是必填的",
	"This is currently not being sent on submit and is pending an update from the team responsible for the API.": "当前未在提交时发送此信息，正在等待负责 API 的团队更新此信息。",
	"This is how your {{serviceName}} instance is referenced in Event Notifications": "这是 {{serviceName}} 实例在 Event Notifications 中的引用方式",
	"This project name \"{{name}}\" already exists, please choose another name.": "此项目名称“{{name}}”已存在，请选择其他名称。",
	"This section is under construction, come back later.": "这部分内容正在建设中，请稍后回来。",
	"This service requires additional storage assigned to the cluster. No matching storage configuration exists.": "此服务需要为该集群分配额外的存储。 不存在匹配的存储配置。",
	"This tag already exists. Choose another name for your tag.": "此标记已存在。 请为标记选择其他名称。",
	"This value already exists.": "此值已存在。",
	"This view is not available for some account types": "此视图对于某些帐户类型不可用。",
	"Three zone names are required": "需要三个专区名称",
	Thursday: Thursday,
	"To add HPCS encryption, follow these steps:": "要添加 HPCS 加密，请按照以下步骤操作：",
	"To connect, the instance in this region must be configured for platform": "要连接，必须为平台配置此区域中的实例",
	"To control the notifications of the events generated by {{serviceName}}, connect to an Event Notifications instance. <a>Learn more</a>": "要控制 {{serviceName}} 所生成事件的通知，请连接 Event Notifications 实例。 <a>了解更多</a>",
	"To create a new HPCS key, follow the steps below...": "要创建新的 HPCS 密钥，请按照以下步骤操作...",
	Tokyo: Tokyo,
	Topics: Topics,
	Toronto: Toronto,
	Total: Total,
	"Total accounts": "帐户总数",
	"Total estimated cost": "估计的总费用",
	"Transaction ID": "事务标识",
	Trash: Trash,
	Trial: Trial,
	"Try again later, or contact your account administrator.": "请稍后重试，或者与您的帐户管理员联系。",
	"Try again later.": "请稍后重试。",
	"Try refreshing the page and then performing the action again to see if the problem persists. If so, make sure you're using a <a>supported browser</a> and check the <a>status page</a> to see if something else is going on. If you're still experiencing an issue reach out to <a>support</a> for help.": "请尝试刷新页面，然后再次执行操作以查看问题是否仍然存在。 如果问题仍然存在，请确保您使用的是<a>支持的浏览器</a>，然后检查<a>状态页面</a>以了解是否发生了其他情况。 如果仍然有问题，请联系<a>支持人员</a>以获取帮助。",
	"Try waiting a few minutes and perform the action again to see if the problem persists. If so, check the <a>status page</a> to see if something else is going on. If you're still experiencing an issue reach out to <a>support</a> for help.": "请试着等几分钟，再执行一次操作，看看问题是否仍然存在。 如果仍然存在，请检查<a>状态页面</a>以确定是否有其他操作正在进行。 如果仍然有问题，请联系<a>支持人员</a>以获取帮助。",
	Tuesday: Tuesday,
	"Type \"{{clusterName}}\" to confirm": "输入“{{agentName}}”以确认",
	"Type \"{{name}}\" to confirm": "输入 \"{{name}}\" 以确认",
	"Unable to configure activity tracker event routing.": "无法配置 Activity Tracker Event Routing。",
	"Unable to configure Activity Tracker integration.": "无法配置 Activity Tracker 集成。",
	"Unable to configure Logging integration.": "无法配置日志记录集成。",
	"Unable to configure logging.": "无法配置日志记录。",
	"Unable to connect your service to Event Notifications service. Try again later.": "无法将服务连接到 Event Notifications 服务。 请稍后重试。",
	"Unable to create authorization policy.": "无法创建授权策略。",
	"Unable to create Satellite location": "无法创建 Satellite 位置",
	"Unable to create the service to service policy at this time. Refresh the page, or try again later.": "此时无法创建服务到服务策略。 请刷新页面或稍后重试。",
	"Unable to delete cluster": "无法删除集群",
	"Unable to disconnect Event Notifications instance. Refresh the page, or try again later.": "无法断开事件通知实例的连接。 请刷新页面或稍后重试。",
	"Unable to get cluster data": "无法获取集群数据",
	"Unable to get Event Notifications instance details. Refresh the page, or try again later.": "无法获取事件通知实例详细信息。 请刷新页面或稍后重试。",
	"Unable to get storage instances.": "无法获取存储实例。",
	"Unable to list clusters.": "无法列出集群。",
	"Unable to list locations.": "无法列出位置。",
	"Unable to load Activity Tracker service catalog data": "无法装入 Activity Tracker 服务目录数据",
	"Unable to load Cloud Logs service catalog data": "无法装入 Cloud Logs 服务目录数据",
	"Unable to load cluster details.": "无法装入集群详细信息。",
	"Unable to load cluster update version options.": "无法装入集群更新版本选项。",
	"Unable to load event routing settings": "无法装入 Event Routing 设置",
	"Unable to load event routing target instances": "无法装入 Event Routing 目标实例",
	"Unable to load event routing target instances.": "无法装入 Event Routing 目标实例",
	"Unable to load event routing targets": "无法装入 Event Routing 目标",
	"Unable to load event routing targets.": "无法装入 Event Routing 目标。",
	"Unable to load IBM Cloud locations data": "无法装入 IBM Cloud 位置数据",
	"Unable to load logging instances": "无法装入日志记录实例",
	"Unable to load logging instances.": "无法加载日志记录实例。",
	"Unable to load logging service catalog data": "无法装入日志记录服务目录数据",
	"Unable to load logs routing targets": "无法装入 Logs Routing 目标",
	"Unable to load logs routing targets.": "无法装入 Logs Routing 目标。",
	"Unable to perform": "无法执行",
	"Unable to retrieve cluster details": "无法检索集群详细信息",
	"Unable to retrieve data": "检索不到数据",
	"Unable to retrieve location information.": "无法检索位置信息。",
	"Unable to retrieve project configurations.": "无法检索项目配置。",
	"Unable to send test notification to Event Notifications instance. Try again later.": "无法将测试通知发送到事件通知实例。 请稍后重试。",
	"Unable to send the test notification to Event Notifications instance. Check if Topics are setup in Event Notifications.": "无法将测试通知发送到事件通知实例。 检查是否在事件通知中设置了主题。",
	"Unable to update cluster version.": "无法更新集群版本。",
	Unknown: Unknown,
	"unknown state": "未知状态",
	"Unselect all rows": "取消选择所有行",
	"Unselect row": "取消选择行",
	Unsupported: Unsupported,
	"Unsupported version. Update the version to continue to receive support.": "不支持的版本。 请更新版本以继续接收支持。",
	"Upcoming scheduled events in your timezone": "时区中即将发生的已调度事件",
	Update: Update,
	"Update available": "可用更新",
	"Update cluster version": "更新集群版本",
	"Update tags": "更新标记",
	"Update version": "更新版本",
	"Updating...": "正在更新...",
	Upgrade: Upgrade,
	"Upgrade your account to view the billing period.": "升级您的帐户以查看结算周期。",
	"Usage based charges apply per gigabyte of audit events ingested.": "每采集一千兆字节的审计事件，应用“基于使用量的费用”",
	"Usage based charges apply per gigabyte of logs ingested.": "每采集一千兆字节的日志，应用\"基于使用量的费用\"",
	"Usage costs": "使用量费用",
	"Use a secret to securely and centrally manage your credentials for authentication. <a>Learn more</a>": "使用私钥来安全地集中管理用于认证的凭证。 <a>了解更多</a>",
	"Use a secret?": "使用私钥？",
	"Use existing": "使用现有",
	"Use key aliases to easily identify your keys. A key alias is a unique and easily recognizable custom name.": "使用密钥别名可以轻松标识密钥。 密钥别名是易于识别的唯一定制名称。",
	"Use tags to organize your resources. If your user tags are billing related, consider writing tags as key:value pairs to help group related tags, such as": "使用标记来组织资源。 如果用户标记与计费相关，请考虑将标记写成“键:值”对，这有助于将相关标记分组，例如",
	"Use the options below to choose the item that the reference will be created for.": "使用以下选项来选择将为其创建引用的项。",
	"User evaluation required": "需要用户评估",
	"User permissions failure": "用户许可权失效",
	"User tags": "用户标记",
	"User tags (optional": "用户标记（可选）",
	"User tags are visible account-wide. Avoid including sensitive data in the tag name.": "用户标记在帐户范围内可见。 请避免在标记名称中包含敏感数据。",
	Value: Value,
	"Value must be a valid array (Ex. [\"array\"]). To specify a null array use \"__NOT_SET__\"": "值必须是有效数组（例如，[\"array\"]）。 要指定空数组，请使用“__NOT_SET__”",
	Values: Values,
	"Verify that the following services have been installed on the location: {{missingServices}}.": "验证是否已在此位置安装以下服务：{{missingServices}}。",
	Version: Version,
	View: View,
	"View all": "查看全部",
	"View audit events": "查看审计事件",
	"View docs": "查看文档",
	"View error information": "查看错误信息",
	"View logging": "查看日志记录",
	"View-only mode": "仅查看方式",
	"VPC Gen1": "VPC 第 1 代",
	"VPC Gen2": "VPC 第 2 代",
	Warning: Warning,
	"warning state": "警告状态",
	"Washington DC": "华盛顿",
	Wednesday: Wednesday,
	"What you will need:": "您将需要：",
	"What's the purpose of this project?": "这个项目的用途是什么？",
	"When you delete the cluster, all worker nodes, apps, and containers are permanently deleted. This action cannot be undone. Before you proceed, make sure to back up all required data and configuration files.": "删除集群时，会永久删除所有工作程序节点、应用程序和容器。 无法撤销此操作。 继续之前，请先确保备份所有必要数据和配置文件。",
	"Worker count": "工作程序计数",
	Workloads: Workloads,
	"Wrong Syntax": "语法错误",
	Yes: Yes,
	"You already have a location with this name. Enter a unique name.": "您已经有一个使用此名称的位置。 请输入唯一的名称。",
	"You already have an instance of Security and Compliance Center. To see results, you must schedule your first scan by creating an attachment.": "您已拥有 Security and Compliance Center 实例。 要查看结果，必须通过创建附件来调度第一次扫描。",
	"You are unable to modify this policy due to your level of access for the policy's resource. If you'd like the ability to modify, contact your administrator to update your resource access.": "由于您对此策略资源的访问级别不足，无法修改此策略。 如果您希望有能力修改，请联系管理员以更新您的资源访问权。",
	"You can find a list of resources here once you create them.": "创建资源后，可以在此处找到这些资源的列表。",
	"You can find your resource details here after you create them.": "创建资源详细信息后，可以在此处找到这些资源详细信息。",
	"You can find your resources here after you create them.": "创建资源后，可以在此处找到所创建的资源。",
	"You can find your Satellite locations here after you create them.": "创建 Satellite 位置后，可以在此处找到所创建的这些位置。",
	"You do not have access to any resource groups.": "您无权访问任何资源组。",
	"You do not have access to any resource groups. <a>Create</a> a resource group.": "您无权访问任何资源组。 <a>创建</a>资源组。",
	"You do not have permission to edit tags. Contact your administrator if you require greater access.": "您无权编辑标记。 如果您需要更大的访问权，请与管理员联系。",
	"You don't have the correct access to add a configuration in \"{{project}}\"": "您没有在“{{project}}”中添加配置的正确访问权",
	"You have restricted access and may not be able to add or remove tags. Contact your administrator if you require greater access.": "您具有受限访问权，可能无法添加或除去标记。 如果您需要更大的访问权，请与管理员联系。",
	"You haven't connected an Event Notifications service instance yet.": "您尚未连接 Event Notifications 服务实例。",
	"You may also <a>create an instance</a>.": "您还可以<a>创建实例</a>。",
	"You may also create a new one.": "您也可以新建一个。",
	"You may have context-based restrictions or IAM policies enabled. Contact your account administrator.": "您可能已启用基于上下文的限制或 IAM 策略。 请联系帐户管理员。",
	"You must have at least one active root key. Try creating a new one.": "至少应有一个有效的根密钥。 尝试新建一个。",
	"You need at least 1 topic to send a test notification.": "您至少需要 1 个主题来发送测试通知。",
	"You need the Editor or Administrator role on the IBM Cloud Projects service to this project. <a>Assign yourself access</a> or request access from your account administrator.": "对于此项目，您需要具有 IBM Cloud Projects 服务的“编辑者”或“管理员”角色。 <a>为自己分配访问权</a>或向帐户管理员请求访问权。",
	"You're adding tags to:": "将标记添加到：",
	"You're editing tags for:": "编辑以下对象的标记：",
	"You're not authorized to connect to this instance. Verify your permissions or contact your administrator.": "您无权连接到此实例。 请验证您的许可权或与管理员联系。",
	"You're using the newest version of the API server. There are no updates available at this time.": "您使用的是最新版本的 API 服务器。 目前没有可用的更新。",
	"You've reached the maximum number of tags that you can attach at a single time. To attach more tags, save your changes first.": "您已达到一次可以附加的最大标记数。 要附加更多标记，请先保存更改。",
	"Your API server is updating to version {{version}}. After it finishes you can update your worker nodes to the same version.": "您的 API 服务器正在更新到版本 {{version}}。 完成后，可以将工作程序节点更新为同一版本。",
	Zone: Zone,
	Zones: Zones,
	"Zoom in image": "放大图像",
	"Zoom out image": "缩小图像"
};

export { About, Access, Account, Actions, Active, Add, Address, Advanced, Aliases, All, Apply, April, Arbitrary, Assign, August, BNPP_EU, Back, Basic, CLI, Cancel, Category, Classic, Clear, Close, Clusters, Complete, Completed, Compliance, Compliant, Configuration, Configure, Confirm, Connect, Connected, Connecting, Containers, Country, Create, Created, Creating, Critical, Current, Custom, Dallas, Datacenter, Datacenters, December, Delete, Deleting, Deploying, Disabled, Disconnect, Docs, Documentation, Done, Download, Draft, Edit, Enabled, Encryption, End, Enterprise, Establish, Expired, Failed, February, Filter, Filters, Finalizing, Frankfurt, Free, Friday, Geography, Help, Hour, IAM, ID, Images, Inactive, Incomplete, Information, Infrastructure, Instance, Instances, Integrations, Invalid, January, July, June, Key, Launch, Lite, Loading, Location, Locations, Logging, London, March, May, Metro, Minute, Monday, Monitoring, Month, Name, Namespace, Namespaces, Next, No, None, Normal, Note, Notification, November, OK, Objects, October, Off, On, Open, Osaka, Overview, Packages, Pattern, Pending, Plan, Premium, Previous, Product, Products, Project, Projects, Property, Provider, Provisioning, Ready, Refresh, Region, Remove, Renew, Repositories, Requested, Required, Reservations, Reset, Resources, Results, Review, Routing, Satellite, Saturday, Save, Scanning, Schedule, Search, Secret, Select, Sending, September, Serverless, Service, Settings, Size, Sort, Source, Start, State, Status, Storage, Submit, Subscription, Success, Summary, Sunday, Sydney, Tags, Thursday, Tokyo, Topics, Toronto, Total, Trash, Trial, Tuesday, Unknown, Unsupported, Update, Upgrade, Value, Values, Version, View, Warning, Wednesday, Workloads, Yes, Zone, Zones, all, code, zhCn as default, hour, hr, mo, more, provided, region, resources, tag, tags };
